import getUserRolePermission from '../utils/role-permission.util';

const useAccess = () => {
  const hasAccess = (role, section) => {
    const accessRights = getUserRolePermission(role);
    return (
      accessRights &&
      accessRights[section] &&
      Object.keys(accessRights[section]).length
    );
  };

  const hasOperationAccess = (role, section, key) => {
    const accessRights = getUserRolePermission(role);
    return (
      accessRights &&
      accessRights[section] &&
      Object.keys(accessRights[section]).length &&
      accessRights[section][key]
    );
  };

  return { hasAccess, hasOperationAccess };
};

export default useAccess;
